import { useState, useEffect } from 'react';
import { SnapshotHistorySetting } from 'types';
import { parseISO, isBefore, differenceInMilliseconds } from 'date-fns';

export const useIsSnapshotRecording = (
  analyzerMode: number | undefined,
  historySettings: SnapshotHistorySetting | undefined
) => {
  const [isRecording, setIsRecording] = useState<boolean>(false);

  useEffect(() => {
    if (analyzerMode === undefined || historySettings === undefined) return;

    if (analyzerMode === 0 && !historySettings?.continuous_mode) {
      setIsRecording(false);
      return;
    }

    if (analyzerMode === 1 && !historySettings?.polling_continuous_mode) {
      setIsRecording(false);
      return;
    }

    if (analyzerMode === 1 && !!historySettings?.polling_continuous_mode) {
      setIsRecording(true);
    } else if (analyzerMode === 0 && !!historySettings?.continuous_mode) {
      const now = new Date();
      const parsedEndDate = parseISO(historySettings?.continuous_mode_end_time);

      if (isBefore(now, parsedEndDate)) {
        const diffInMs = differenceInMilliseconds(parsedEndDate, now);
        setIsRecording(true);
        setTimeout(() => {
          setIsRecording(false);
        }, diffInMs);
      } else {
        setIsRecording(false);
      }
    }
  }, [analyzerMode, historySettings]);

  return isRecording;
};
